import "@Styles/guestLayout.scss";
import React, { useContext } from "react";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";
import { RouteComponentProps } from "react-router";
import { getBranding } from "@Branding";
import { Col, Row, Typography } from "antd";
import Logo from "@Components/shared/Logo";
import { PublicAssetsUrl } from "@Constants";

type IProps = RouteComponentProps & { children: any };

const GuestLayout: React.FC<IProps> = (props: IProps & RouteComponentProps<any>) => {
    const videoSrc = getBranding("video-background");
    const { Title } = Typography;
    const { ui: uiState, settingMode } = useContext(MainContext);

    const settingCurrentMode = (width) => {
        // TABLET VIEW
        if (width <= 1100 && width >= 750) {
            settingMode(ViewMode.tablet);
        } else {
            // DESKTOP VIEW
            if (width > 1100) {
                settingMode(ViewMode.desktop);
            }
            // MOBILE VIEW
            if (width < 750) {
                settingMode(ViewMode.mobile);
            }
        }
    };

    const handleResizeViewport = (e) => {
        const currentWidth = e.target.innerWidth;
        settingCurrentMode(currentWidth);
    };
    window.addEventListener("resize", handleResizeViewport);
    React.useEffect(() => {
        const currentWidth = window.innerWidth;
        settingCurrentMode(currentWidth);
    }, []);

    return (
        <div id="guest-layout" className="layout">
            {uiState.mode === ViewMode.desktop ? (
                <Row style={{ height: "100vh", position: "relative" }}>
                    <div style={{ overflow: "hidden", margin: "0 auto" }}>
                        <video autoPlay loop muted className="login-video" style={{ left: "-25%" }}>
                            <source src={videoSrc} type="video/mp4" />
                        </video>
                    </div>
                    <Col span={12}>
                        <div className="login-container">
                            <div className="login-header">
                                <Logo style={{ height: "80px", scale: getBranding("login-logo-scale") }} />
                            </div>
                            <Title className="login-subheader">
                                Surgical training <span className="inovus-blue-text">remastered.</span>
                            </Title>
                            <div className="login-image-container">
                                <img
                                    src={`${PublicAssetsUrl}/web/LoginImageLeft.png`}
                                    alt="login-img-left"
                                    className="login-image-left"
                                />
                                <img
                                    src={`${PublicAssetsUrl}/web/LoginImageCenter.png`}
                                    alt="login-img-center"
                                    className="login-image-center"
                                />
                                <img
                                    src={`${PublicAssetsUrl}/web/LoginImageRight.png`}
                                    alt="login-img-right"
                                    className="login-image-right"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ backgroundColor: "white" }}>{props.children}</div>
                    </Col>
                </Row>
            ) : (
                <div>
                    <div style={{ overflow: "hidden", margin: "0 auto" }}>
                        <video autoPlay loop muted className="login-video">
                            <source src={videoSrc} type="video/mp4" />
                        </video>
                    </div>
                    <div className="login-container">
                        <div className="login-header">
                            <Logo
                                style={{
                                    height: "80px",
                                    scale: getBranding("login-logo-scale"),
                                    color: "white",
                                }}
                            />
                        </div>
                        <Title className="login-subheader" style={{ marginBottom: "80px" }}>
                            Surgical training <span className="inovus-blue-text">remastered.</span>
                        </Title>
                        <>{props.children}</>
                    </div>
                </div>
            )}
        </div>
    );
};
export default GuestLayout;
